import { render, staticRenderFns } from "./SurveyPaperManage.vue?vue&type=template&id=3efce542&"
import script from "./SurveyPaperManage.vue?vue&type=script&lang=js&"
export * from "./SurveyPaperManage.vue?vue&type=script&lang=js&"
import style0 from "./SurveyPaperManage.vue?vue&type=style&index=0&id=3efce542&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3efce542')) {
      api.createRecord('3efce542', component.options)
    } else {
      api.reload('3efce542', component.options)
    }
    module.hot.accept("./SurveyPaperManage.vue?vue&type=template&id=3efce542&", function () {
      api.rerender('3efce542', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/contents/survey-paper-manage/SurveyPaperManage.vue"
export default component.exports